import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";
import axios from "axios";

const Branch = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [franchises, setFranchises] = useState([]);
  const [selectedFrArea1, setSelectedFrArea1] = useState("");
  const [selectedFrArea2, setSelectedFrArea2] = useState("");
  const [selectedDong, setSelectedDong] = useState("");
  const [gunguList, setGunguList] = useState([]);
  const [dongList, setDongList] = useState([]);
  const [franchList, setFranchList] = useState([]);
  const [mapVisible, setMapVisible] = useState([]);

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 교육원 검색`;

    window.gtag("config", "G-LYT78YCDYK", { page_path: location.pathname });

    const checkIP = async () => {
      const response = await fetch("/check-ip");
      const result = await response.json();
      if (result.redirect) {
        navigate(result.redirect);
      }
    };

    checkIP();

    const fetchArea = async () => {
      try {
        const response = await axios.get("/franchise");
        const result = response.data;
        const areas = [
          ...new Set(result.map((item) => item.frArea1.trim().toLowerCase())),
        ];
        areas.sort((a, b) => a.localeCompare(b));
        setFranchises(areas);
      } catch (error) {
        console.error("Error fetching franchise list:", error);
      }
    };
    fetchArea();
  }, [location, navigate]);

  const handleSidoChange = async (e) => {
    const selectedValue = e.target.value;
    setSelectedFrArea1(selectedValue);
    setSelectedFrArea2(""); // frArea2 초기화

    // frArea2 select 요소의 value를 빈 값으로 설정
    document.getElementById("gungu_list_s").value = "";

    try {
      const response = await axios.get("/franSigungu", {
        params: { frArea1: selectedValue },
      });
      const gunguData = response.data;
      const frArea2Values = gunguData.map((item) =>
        item.frArea2.trim().toLowerCase()
      );
      const uniqueFrArea2 = [...new Set(frArea2Values)];
      uniqueFrArea2.sort((a, b) => a.localeCompare(b));
      setGunguList(uniqueFrArea2);
      setDongList([]);
      setFranchList([]);
    } catch (error) {
      console.error("Error fetching gungu list:", error);
    }
  };

  const handleGunguChange = async (e) => {
    const selectedGungu = e.target.value;
    setSelectedFrArea2(selectedGungu);
    try {
      const response = await axios.get("/franDong", {
        params: { frArea1: selectedFrArea1, frArea2: selectedGungu },
      });
      const dongData = response.data;
      const dongValues = dongData.map((item) =>
        item.frArea3.trim().toLowerCase()
      );
      const uniqueDongValues = [...new Set(dongValues)];
      uniqueDongValues.sort((a, b) => a.localeCompare(b));
      setDongList(uniqueDongValues);
      setFranchList([]);
    } catch (error) {
      console.error("Error fetching dong list:", error);
    }
  };

  const handleSearch = async () => {
    try {
      const params = {
        frArea1: selectedFrArea1, // frArea1은 항상 전달
      };

      // frArea2가 선택되었을 때만 추가
      if (selectedFrArea2 && selectedFrArea2.trim() !== "") {
        params.frArea2 = selectedFrArea2;
      }

      // frArea3가 선택되었을 때만 추가
      if (selectedDong && selectedDong.trim() !== "") {
        params.frArea3 = selectedDong;
      }

      const response = await axios.get("/franSerch", { params });
      const franchData = response.data;

      console.log(franchData);

      // frArea1이 '세종특별자치시'일 때 frArea2 기준으로 정렬하고, 그렇지 않으면 frArea3 기준으로 정렬
	  franchData.sort((a, b) => {
	    if (a.frArea1 === "세종특별자치시") {
	      // 세종특별자치시의 경우 frArea2를 기준으로 정렬
	      const area2Comparison = a.frArea2.localeCompare(b.frArea2, "ko");
	      if (area2Comparison !== 0) {
	        return area2Comparison; // frArea2가 다르면 이 기준으로 정렬
	      } else {
	        return a.frTitle.localeCompare(b.frTitle, "ko"); // frArea2가 같으면 frTitle로 정렬
	      }
	    } else {
	      // 그 외 지역의 경우 frArea3를 기준으로 정렬
	      const area3Comparison = a.frArea3.localeCompare(b.frArea3, "ko");
	      if (area3Comparison !== 0) {
	        return area3Comparison; // frArea3이 다르면 이 기준으로 정렬
	      } else {
	        return a.frTitle.localeCompare(b.frTitle, "ko"); // frArea3이 같으면 frTitle로 정렬
	      }
	    }
	  });
      setFranchList(franchData);
      setMapVisible(Array(franchData.length).fill(false));
    } catch (error) {
      console.error("Error fetching branch data:", error);
    }
  };

  const toggleMap = (index) => {
    setMapVisible((prev) => {
      const newVisible = Array(franchList.length).fill(false);
      newVisible[index] = !prev[index];
      console.log(franchList);
      return newVisible;
    });
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://dapi.kakao.com/v2/maps/sdk.js?appkey=d89224e6a469dfbd13e78b03285c57f8&autoload=false";
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      const { kakao } = window;

      // kakao.maps.load를 사용하여 지도를 초기화합니다.
      kakao.maps.load(() => {
        franchList.forEach((franch, index) => {
          if (mapVisible[index]) {
            // 해당 index의 맵이 보일 때만
            const mapContainer = document.getElementById(`acc_${index}`);
            const mapOption = {
              center: new kakao.maps.LatLng(franch.agGpsX, franch.agGpsY), // 프랜차이즈의 GPS 좌표
              level: 3, // 지도의 확대 레벨
            };

            const map = new kakao.maps.Map(mapContainer, mapOption);

            // // 마커 추가
            const imageSrc = "../../custom-resources/images/map/marker_asobi.png",
              imageSize = new kakao.maps.Size(64, 69),
              imageOption = { offset: new kakao.maps.Point(27, 69) };

            const markerImage = new kakao.maps.MarkerImage(
              imageSrc,
              imageSize,
              imageOption
            );

            const markerPosition = new kakao.maps.LatLng(
              franch.agGpsX,
              franch.agGpsY
            );
            const marker = new kakao.maps.Marker({
              position: markerPosition,
              image: markerImage,
            });

            marker.setMap(map); // 마커를 지도에 표시
          }
        });
      });
    };

    // 컴포넌트 언마운트 시 스크립트 제거
    return () => {
      document.head.removeChild(script);
    };
  }, [franchList, mapVisible]); // franchList와 mapVisible을 의존성 배열에 추가

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/presence">아소비 입회</a>
              </li>
              <li>
                <a href="/diagnostic">진단 테스트</a>
              </li>
              <li>
                <a href="/sptp">SPTP 종합심리검사</a>
              </li>
              <li>
                <a href="/branch" className="sel">
                  우리 동네 아소비
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <section id="container">
        <div className="subvisual">
          <div className="title">아소비 입회</div>
          <div className="text">
            초등학교 입학 전후, 우리아이 교육이 걱정되신다면 <br />
            지금 유기농공부 아소비로 시작해보세요!
          </div>
          <div className="image">
            <img src="../custom-resources/img/sub_presence_bg.png" alt="" />
          </div>
        </div>
        <div className="breadcrumb">
          <div className="wrap">
            <div className="loca">
              <span>
                <img src="../custom-resources/img/icon_home.png" alt="" />
              </span>
              <span className="on">아소비 입회</span>
            </div>
            <div className="menu">
              <a href="/diagnostic">진단 테스트</a>
              <a href="/sptp">SPTP 종합심리검사</a>
              <a href="/branch" className="on">
                우리 동네 아소비
              </a>
            </div>
          </div>
        </div>
        <div className="store">
          <div className="wrap">
            <div className="sect">
              <div className="tit">우리 동네 아소비</div>
              <div className="txt">
                현재 전국 방방곡곡 유기농공부 아소비가 있습니다. <br />
                지금 가까운 곳의 우리 동네 아소비를 찾아 보세요!
              </div>
            </div>
            <div className="search">
              <p>주소 검색으로 가까운 우리 동네 아소비를 검색해주세요!</p>
              <div className="input">
                <select
                  name="sido_list_s"
                  id="sido_list_s"
                  onChange={handleSidoChange}
                >
                  <option value="">시도</option>
                  {franchises.map((area, index) => (
                    <option key={index} value={area}>
                      {area}
                    </option>
                  ))}
                </select>
                <select
                  name="gungu_list_s"
                  id="gungu_list_s"
                  onChange={handleGunguChange}
                >
                  <option value="">시/군/구</option>
                  {gunguList.map((gungu, index) => (
                    <option key={index} value={gungu}>
                      {gungu}
                    </option>
                  ))}
                </select>
                <select
                  name="dong_list_s"
                  id="dong_list_s"
                  onChange={(e) => setSelectedDong(e.target.value)}
                >
                  <option value="">동/읍/면</option>
                  {dongList.map((dong, index) => (
                    <option key={index} value={dong}>
                      {dong}
                    </option>
                  ))}
                </select>
                <button onClick={handleSearch}>검색</button>
              </div>
            </div>
            <div className="list">
              <div className="in">
                <p>
                  <img src="../custom-resources/img/icon_house_home.png" alt="" />{" "}
                  공부방
                </p>
              </div>
              <ul className="hd">
                <li>
                  <div className="desc">동/읍/면</div>
                  <div className="desc">교육원 정보</div>
                  <div className="desc">문의</div>
                  <div className="desc">지도</div>
                </li>
              </ul>
              <ul className="bd">
                {franchList.map((franch, index) => (
					<li
					  key={index}
					  onClick={() => toggleMap(index)}
					  style={{ cursor: "pointer" }}
					>
                    <div className="head">
                      <div className="desc">
					  <div className="addr">
					    {franch.frArea1 === "세종특별자치시"
					      ? franch.frArea2
					      : franch.frArea3}
					  </div>
					  </div>
                      <div className="desc">
                        <div className="name">
                          <i className="home"></i>
                          {franch.frTitle}
                        </div>
                        <div className="tele">
                          <i className="home"></i>T: {franch.frTel}
                        </div>
                      </div>
					  <div
					    className="desc"
					    onClick={(e) => e.stopPropagation()}
					    style={{ cursor: "auto" }}
					  >
                        <div className="link">
                          <a
                            href={franch.frKakaoLink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="../custom-resources/img/icon_ch.png"
                              alt="kakao"
                            />
                          </a>
                          <a href="/oneonone">
                            <img
                              src="../custom-resources/img/icon_ps.png"
                              alt="oneonone"
                            />
                          </a>
                        </div>
                      </div>
					  <div
					    className="desc"
					    onClick={(e) => e.stopPropagation()}
					    style={{ cursor: "auto" }}
					  >
                        <div className="zido">
                          <button
                            onClick={() => toggleMap(index)}
                            style={{ backgroundColor: "#fff" }}
                          >
                            <img src="../custom-resources/img/icon_map.png" alt="" />
                          </button>
                        </div>
                      </div>
                    </div>
                    {mapVisible[index] && (
                      <div
                        className="map_cont"
                        id={`mapdiv_${index}`}
                        style={{
                          display: mapVisible[index] ? "block" : "none",
                        }}
                      >
                        <div className="info">
                          <div className="name">{franch.frTitle}</div>
                          <div className="con">
                            <dl>
                              <dt>
                                <img
                                  src="../custom-resources/img/icon_tel.png"
                                  alt=""
                                />
                              </dt>
                              <dd>
                                <p>{franch.frTel}</p>
                              </dd>
                            </dl>
                            <dl>
                              <dt>
                                <img
                                  src="../custom-resources/img/icon_addr.png"
                                  alt=""
                                />
                              </dt>
                              <dd>
                                <p>{`[도로] ${franch.frAddr1}`}</p>
                              </dd>
                            </dl>
                          </div>
                        </div>
                        <div className="map">
                          <div className="accs" id={`acc_${index}`} style={{height:"330px"}}></div>
                        </div>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Branch;
